export default __webpack_public_path__ + "static/media/todolist.aa9cadbd.mp4";